export default {
  "container": "_container_1r6tvw",
  "form-title": "_form-title_1r6tvw",
  "buttons": "_buttons_1r6tvw"
};
